// extracted by mini-css-extract-plugin
export default {"tooltip":"RatioChart_tooltip__mPxiZ","tooltipDate":"RatioChart_tooltipDate__ebHKT","tooltipRatio":"RatioChart_tooltipRatio__JzJSq","tooltipDelta":"RatioChart_tooltipDelta__mQ1Dl"};